import React, { useState, useEffect } from "react";
import "../docTemplateConverter.css";
import {
  FiArrowLeft,
  FiFileText,
  FiBell,
  FiCheck,
  FiZap,
  FiLayout,
  FiRefreshCw,
  FiCheckSquare
} from "react-icons/fi";

function DocTemplateConverterPage({ onBackToHome }) {
  const [email, setEmail] = useState("");
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [countdown, setCountdown] = useState({
    days: 45,
    hours: 12,
    minutes: 30,
    seconds: 0
  });

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        let { days, hours, minutes, seconds } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else if (days > 0) {
          days--;
          hours = 23;
          minutes = 59;
          seconds = 59;
        }
        return { days, hours, minutes, seconds };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email.trim()) {
      setIsSubscribed(true);
    }
  };

  const features = [
    {
      icon: FiLayout,
      title: "Template Compliance",
      description: "Automatically reformat documents to comply with the latest template standards"
    },
    {
      icon: FiRefreshCw,
      title: "Auto-Reformatting",
      description: "Intelligent content reorganization while preserving original information"
    },
    {
      icon: FiCheckSquare,
      title: "BMS Guidelines",
      description: "Built-in support for BMS guidelines including SOPs and Work Instructions"
    },
    {
      icon: FiFileText,
      title: "Content Preservation",
      description: "Preserves and reorganizes original content without loss of information"
    }
  ];

  return (
    <div className="coming-soon-page">
      <div className="coming-soon-bg">
        <div className="bg-gradient-1"></div>
        <div className="bg-gradient-2"></div>
      </div>

      <button className="back-button" onClick={onBackToHome}>
        <FiArrowLeft className="back-icon" />
        <span>Back to Home</span>
      </button>

      <div className="coming-soon-content">
        <div className="coming-soon-hero">
          <div className="coming-soon-icon-wrapper">
            <FiFileText className="coming-soon-icon" />
            <div className="icon-pulse"></div>
          </div>

          <div className="coming-soon-badge-container">
            <span className="coming-soon-badge-large">
              <FiZap className="badge-icon-large" />
              Coming Soon
            </span>
          </div>

          <h1 className="coming-soon-title">
            Document <span className="highlight">Template Converter</span>
          </h1>

          <p className="coming-soon-subtitle">
            An intelligent application that automates reformatting Word documents
            into the latest, template-compliant formats. Preserves and reorganizes
            original content per BMS guidelines.
          </p>

          <div className="countdown-container">
            <h3 className="countdown-label">Launching In</h3>
            <div className="countdown-timer">
              <div className="countdown-item">
                <span className="countdown-value">
                  {String(countdown.days).padStart(2, "0")}
                </span>
                <span className="countdown-unit">Days</span>
              </div>
              <span className="countdown-separator">:</span>
              <div className="countdown-item">
                <span className="countdown-value">
                  {String(countdown.hours).padStart(2, "0")}
                </span>
                <span className="countdown-unit">Hours</span>
              </div>
              <span className="countdown-separator">:</span>
              <div className="countdown-item">
                <span className="countdown-value">
                  {String(countdown.minutes).padStart(2, "0")}
                </span>
                <span className="countdown-unit">Minutes</span>
              </div>
              <span className="countdown-separator">:</span>
              <div className="countdown-item">
                <span className="countdown-value">
                  {String(countdown.seconds).padStart(2, "0")}
                </span>
                <span className="countdown-unit">Seconds</span>
              </div>
            </div>
          </div>

          <div className="subscribe-section">
            {!isSubscribed ? (
              <>
                <p className="subscribe-text">
                  <FiBell className="subscribe-icon" />
                  Get notified when we launch
                </p>
                <form className="subscribe-form" onSubmit={handleSubscribe}>
                  <input
                    type="email"
                    className="subscribe-input"
                    placeholder="Enter your email address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  <button type="submit" className="subscribe-button">
                    Notify Me
                  </button>
                </form>
              </>
            ) : (
              <div className="subscribe-success">
                <div className="success-icon-wrapper">
                  <FiCheck className="success-icon" />
                </div>
                <h3 className="success-title">You're on the list!</h3>
                <p className="success-text">
                  We'll notify you at <strong>{email}</strong> when Document Template Converter launches.
                </p>
              </div>
            )}
          </div>
        </div>

        <div className="features-preview">
          <h2 className="features-title">What to Expect</h2>
          <div className="features-grid">
            {features.map((feature, index) => {
              const FeatureIcon = feature.icon;
              return (
                <div key={index} className="feature-card">
                  <div className="feature-icon-wrapper">
                    <FeatureIcon className="feature-icon" />
                  </div>
                  <h3 className="feature-title">{feature.title}</h3>
                  <p className="feature-description">{feature.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default DocTemplateConverterPage;
